// @flow

import type { JWTRole } from "types/overclick";

const ROLE_LABELS: { [JWTRole]: string } = {
  adm: "Administrator",
  him: "Head Advertiser Manager",
  ham: "Head Affiliate Manager",
  inm: "Advertiser Manager",
  afm: "Affiliate Manager",
  aff: "Affiliate",
};

function getRoleLabel(role: JWTRole): string {
  return ROLE_LABELS[role] || role;
}

export default getRoleLabel;
